module.exports = __webpack_public_path__ + "img/gilliantoboni.com.f0463bfd.jpg";